import React from 'react';
import { Layout, GetInfo } from '../components';
import '../assets/styles/containers/Prices.sass';

const Prices = () => {
  return (
    <div className="Prices">
      <Layout bannerId={68}>
        <div className="container">
          <GetInfo id={135}/>
        </div>
      </Layout>
    </div>
  );
};

export default Prices;
